export { default } from './SkeletonPopularDestinations';
